import L from 'leaflet';
import { LayerType } from './map-types';

const getMapApiKey = () => {
  const DEV_MAP_API_KEY = 'jQn8jxvrBnPVYZ8L_v2p6WHorAcfiFdTbP22iA6Yitc';
  const PROD_MAP_API_KEY = 'mrtwB_vFVe_g7g9c4tVlUh9Pni2BDszmswCaD60VBdk';

  if (
    process.env.NODE_ENV === 'development' ||
    window.origin.includes('localhost')
  ) {
    return DEV_MAP_API_KEY;
  }
  if (
    window.origin.includes('crzp-dev.mzp.cz') ||
    window.origin.includes('crzp-test.mzp.cz')
  ) {
    return DEV_MAP_API_KEY;
  }

  return PROD_MAP_API_KEY;
};

export const MAP_API_KEY = getMapApiKey();

// Define layer URLs according to Mapy.cz documentation
const LAYER_URLS = {
  [LayerType.BASE]: `https://api.mapy.cz/v1/maptiles/basic/256/{z}/{x}/{y}?apikey=${MAP_API_KEY}`,
  [LayerType.AERIAL]: `https://api.mapy.cz/v1/maptiles/aerial/256/{z}/{x}/{y}?apikey=${MAP_API_KEY}`,
  [LayerType.OUTDOOR]: `https://api.mapy.cz/v1/maptiles/outdoor/256/{z}/{x}/{y}?apikey=${MAP_API_KEY}`,
  [LayerType.WINTER]: `https://api.mapy.cz/v1/maptiles/winter/256/{z}/{x}/{y}?apikey=${MAP_API_KEY}`,
};

const attribution = `<a href="https://api.mapy.com/copyright" target="_blank">&copy; Seznam.cz a.s. a další</a>`;

// Create layer instances

export const getLayers = (): Record<LayerType, L.TileLayer> => ({
  [LayerType.BASE]: L.tileLayer(LAYER_URLS[LayerType.BASE], {
    attribution,
    minZoom: 2,
    maxZoom: 19,
  }),
  [LayerType.AERIAL]: L.tileLayer(LAYER_URLS[LayerType.AERIAL], {
    attribution,
    minZoom: 2,
    maxZoom: 19,
  }),
  [LayerType.OUTDOOR]: L.tileLayer(LAYER_URLS[LayerType.OUTDOOR], {
    attribution,
    minZoom: 2,
    maxZoom: 19,
  }),
  [LayerType.WINTER]: L.tileLayer(LAYER_URLS[LayerType.WINTER], {
    attribution,
    minZoom: 2,
    maxZoom: 19,
  }),
});

// Layer names for UI
export const layerNames: Record<LayerType, string> = {
  [LayerType.BASE]: 'Základní',
  [LayerType.AERIAL]: 'Letecká',
  [LayerType.OUTDOOR]: 'Turistická',
  [LayerType.WINTER]: 'Zimní',
};

export const MapyAttributionLogoControl = L.Control.extend({
  options: {
    position: 'bottomleft',
  },

  onAdd: function () {
    const container = L.DomUtil.create('div');
    const link = L.DomUtil.create('a', '', container);

    link.setAttribute('href', 'http://mapy.cz/');
    link.setAttribute('target', '_blank');
    link.innerHTML = '<img src="https://api.mapy.com/img/api/logo.svg" />';
    L.DomEvent.disableClickPropagation(link);

    return container;
  },
});
